import { Box, MenuItem, Select, alpha, styled } from '@mui/material';
import { DateRangePicker } from '@mui/x-date-pickers-pro';

export const FilterPanelRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  // padding: '0.75rem',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '0.875rem',
  boxShadow: '0 0.0625rem 0.25rem 0.0625rem rgba(0, 0, 0, 0.1)',
  width: '32rem',
  maxWidth: '90vw',
  maxHeight: '70vh',
}));

export const FilterFieldsScrollArea = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});

export const FilterFieldContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  width: '100%',
  minWidth: '30rem',

  '& .MuiInputBase-root': {
    border: 'none',
    padding: '0.75rem 0.5rem !important',
  },
});

export const FilterLabel = styled('label')(({ theme }) => ({
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.625rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: theme.palette.grey[800],
}));

export const FilterInput = styled('input')(({ theme }) => ({
  height: '2.5rem',
  padding: '0.5rem 0.75rem',
  border: 'none',
  borderRadius: '0.625rem',
  backgroundColor: theme.palette.grey[50],
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: '#615E6F',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',

  '&::placeholder': {
    color: `${theme.palette.grey[600]} !important`,
    opacity: 1,
  },

  '&:focus': {
    outline: 'none',
  },
}));

export const FilterSelect = styled(Select)(({ theme }) => ({
  height: '2.5rem',
  borderRadius: '0.625rem',
  backgroundColor: theme.palette.grey[50],
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: '#807D93',

  '& .MuiSelect-select': {
    padding: '0.5rem 0.75rem',
    paddingRight: '2rem !important',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '& .MuiSelect-icon': {
    color: '#807D93',
    right: '0.5rem',
  },
}));

export const FilterMenuItem = styled(MenuItem)({
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: '#615E6F',
});

export const DateRangeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '2.5rem',
  padding: '0.5rem',
  borderRadius: '0.625rem',
  backgroundColor: theme.palette.grey[50],
  gap: '0.5rem',
}));

export const DateRangePickerFilter = styled(DateRangePicker)(({ theme }) => ({
  flex: 1,
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: '#615E6F',
  outline: 'none',
  textAlign: 'center',
  minWidth: 0,

  '& .MuiFormControl-root': {
    width: 'calc(50% - 1rem) !important',
  },

  '& .MuiInputBase-root': {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '0 !important',
    cursor: 'pointer',
  },

  '& .MuiInputBase-root input': {
    color: `${theme.palette.grey[600]} !important`,
    fontFamily: 'Neue Frutiger World',
    fontWeight: 'normal',
    width: '4.5rem',
    cursor: 'pointer',
  },

  '& .MuiInputBase-root fieldset': {
    border: 'none',
  },

  '& .MuiInputBase-root input::placeholder': {
    opacity: 1,
  },
}));

export const DateRangeSeparator = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#807D93',
  fontSize: '0.75rem',
});

export const RangeInputContainer = styled(Box)({
  display: 'flex',
  gap: '0.625rem',
  width: '100%',
});

export const RangeInput = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  height: '2.5rem',
  padding: '0.5rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.75rem',
  borderRadius: '0.625rem',
  backgroundColor: theme.palette.grey[50],
  gap: '0.625rem',
}));

export const RangeInputField = styled('input')(({ theme }) => ({
  flex: 1,
  border: 'none',
  backgroundColor: 'transparent',
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: '#615E6F',
  outline: 'none',
  minWidth: 0,

  '&::placeholder': {
    color: `${theme.palette.grey[600]} !important`,
    opacity: 1,
  },

  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },

  '&[type=number]': {
    MozAppearance: 'textfield',
  },
}));

export const RangeInputIcon = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#807D93',
  flexShrink: 0,

  '& svg': {
    fontSize: '0.9375rem',
  },
});

export const CheckboxListContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.125rem',
  borderRadius: '0.625rem',
  backgroundColor: theme.palette.grey[50],
  padding: '0.25rem 0',
}));

export const CheckboxListItem = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.25rem 0.75rem',
  cursor: 'pointer',
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: '#615E6F',
  transition: 'background-color 0.15s ease',

  '&:hover': {
    backgroundColor: alpha(theme.palette.accent.main, 0.06),
  },
}));

export const checkboxSx = {
  padding: '0.125rem',
  color: '#807D93',
  '&.Mui-checked': {
    color: 'accent.main',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
  },
};

export const radioSx = {
  padding: '0.125rem',
  color: '#807D93',
  '&.Mui-checked': {
    color: 'accent.main',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
  },
};

export const PredefinedFiltersSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  paddingBottom: '0.5rem',
  marginBottom: '0.5rem',
  borderBottom: '1px solid #E5E5E5',
});

export const PredefinedFiltersLabel = styled('label')(({ theme }) => ({
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.625rem',
  fontWeight: 400,
  lineHeight: 1.6,
  color: theme.palette.grey[800],
}));

export const PredefinedFiltersContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.375rem',
});

export const PredefinedFilterChip = styled(Box)<{ selected?: boolean }>(({ theme, selected }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.25rem 0.625rem',
  borderRadius: '0.5rem',
  backgroundColor: selected ? theme.palette.accent.main : '#F7F7F8',
  border: `1px solid ${selected ? theme.palette.accent.main : '#E0DFE5'}`,
  fontFamily: 'Neue Frutiger World',
  fontSize: '0.6875rem',
  fontWeight: 400,
  color: selected ? '#FFFFFF' : '#615E6F',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
  userSelect: 'none',

  '&:hover': {
    backgroundColor: selected ? theme.palette.accent.dark : '#EEEEF0',
    borderColor: selected ? theme.palette.accent.dark : '#BCBAC7',
  },
}));

export const FilterActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0.5rem',
  marginTop: '0.5rem',
  padding: '0.5rem 0.75rem 0.75rem 0.75rem',
  borderTop: '1px solid #E5E5E5',
});

export const dateRangeIconSx = {
  fontSize: '0.9375rem',
  color: '#807D93',
};

export const arrowForwardIconSx = {
  fontSize: '0.625rem',
  margin: '0 !important',
};

export const selectMenuPaperSx = {
  borderRadius: '0.625rem',
  boxShadow: '0 0.125rem 0.5rem rgba(0, 0, 0, 0.1)',
};

export const filterPopoverPaperSx = {
  marginTop: '0.5rem',
  borderRadius: '0.875rem',
  boxShadow: '0 0.0625rem 0.25rem 0.0625rem rgba(0, 0, 0, 0.1)',
};
